import type { NextPage } from 'next'
import styles from '../../styles/form/imageInput2.module.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import { joinClassnames } from 'helpers/classNames'
import { faLock, faEnvelope, faUser } from '@fortawesome/free-solid-svg-icons'
import { isDev } from 'app/general'
import { PiFileVideoLight } from "react-icons/pi";

library.add(faLock, faEnvelope, faUser)

interface Props {
  video: string
  setVideoToUpload?: any
  uploadImageImmediately?: any
  text?: string
  showVideo?: boolean
  setVideoToShow?: any
  size?: string
  break?: boolean
  placeholderImage?: string
  justIcon?: boolean
}


const VideoInputComponent: NextPage<Props> = (props: Props) => {
  // const size = props.size
  // const [video, setVideo] = useState<string>('')
  const MAX_SIZE = 10 * 1000000 // 10MB

  const videoInputOnChange = async (e: any) => {
    if (e.target.files[0].size > MAX_SIZE) {
       isDev && console.log(e.target.files[0].size, MAX_SIZE)
      alert("File is too big!");
      props.setVideoToShow('')
      return
    };
    props.setVideoToShow(URL.createObjectURL(e.target.files[0]))


    // const blob = new Blob([new Uint8Array(decode(image.base64String as string))], {
    //   type: `image/${image.format}`,
    // });

    // const file = new File([blob], "Name", {
    //   lastModified: moment().unix(),
    //   type: blob.type,
    // });
    props.setVideoToUpload(e.target.files[0])

    props.setVideoToShow(URL.createObjectURL(e.target.files[0]))
  }

  // const saveVideo = async (img: Blob) => {
  //   const resizedImage: any = await resizeFile(img);
  //   setImage(URL.createObjectURL(img))
  //   if (props.setImageToShow) props.setImageToShow(URL.createObjectURL(img))
  //   if (props.setImageToUpload) props.setImageToUpload(resizedImage)
  //   if (props.uploadImageImmediately) {
  //     props.uploadImageImmediately(resizedImage) || reset()
  //   }
  // }

  // const takePicture = async () => {
  //   const image = await Camera.getPhoto({
  //     quality: 90,
  //     allowEditing: true,
  //     resultType: CameraResultType.Base64,
  //     source: Capacitor.isNativePlatform() ? CameraSource.Prompt : CameraSource.Photos,
  //   });

  //   if (!image) return  isDev && console.log('No image taken');

  //   const blob = new Blob([new Uint8Array(decode(image.base64String as string))], {
  //     type: `image/${image.format}`,
  //   });

  //   const file = new File([blob], "Name", {
  //     lastModified: moment().unix(),
  //     type: blob.type,
  //   });
  //   saveVideo(file)
  // }
  const reset = () => {
    props.setVideoToUpload('')
  }

  let className = styles.image_upload_input
  const combinedClassNames = joinClassnames([
    className,
    props.size === 'small' && styles.small,
    props.size === 'auto_size' && styles.auto_size,
    props.size === 'xSmall' && styles.xSmall,
    props.size === 'xxSmall' && styles.xxSmall,
  ])

  return (
    <div className={styles.image_upload_wrapper}>

      {/* 
      {props.showImage && (
        <div className={styles.image_wrapper}>
          <img className={styles.image} src={image || props.placeholderImage} />
        </div>
      )}
      {props.break && <Break size={Size.xSmall} />} */}

      {props.showVideo && props.video && (
        <div className={styles.image_wrapper}>
          <video src={props.video || props.placeholderImage} id="video" width="320" height="240" controls></video>
        </div>

      )}


      <label htmlFor="video-upload">
        {props.justIcon &&
          <div className={styles.centerV}>
            <PiFileVideoLight color='white' size={30}/>
             {/* <IconComponent src="/icons/Icon_videoicon_.svg" type={"8"} square border size={Size.small} /> */}
          </div>
        }
        {!props.justIcon &&
          <div className={combinedClassNames}>
            <div className={styles.text}>
              {props.text ? props.text : 'Choose Video'}
            </div>
          </ div>
        }
      </label>
      <input id="video-upload" type="file" accept="video/mp4,video/x-m4v,video/*" onChange={videoInputOnChange} style={{ display: "none" }} />
    </div>
  )
};

export default VideoInputComponent;